export default __webpack_public_path__ + "static/media/3.19f0d3e5.jpg";